import { render, staticRenderFns } from "./OtherSwitch.vue?vue&type=template&id=100fb156&scoped=true&"
import script from "./OtherSwitch.vue?vue&type=script&lang=js&"
export * from "./OtherSwitch.vue?vue&type=script&lang=js&"
import style0 from "./OtherSwitch.vue?vue&type=style&index=0&id=100fb156&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100fb156",
  null
  
)

export default component.exports